<template>
	<div id="detail">
		<img alt="Vue logo" src="../../assets/detail.png">
		<Footer></Footer>
	</div>
</template>

<script>
	export default{
//  
	}
</script>

<style>
	#detail {
	position: relative;
	}
	img {
		width: 100%;
		height: 100%;
	}
	
	
</style>
